module.exports = __webpack_public_path__ + "img/Facebook.8a7d02c4.svg";